import i18next from 'i18next';

const defaultOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export const formatDateValueUTC = (date: number, locale: string) => {
  try {
    return new Intl.DateTimeFormat(locale, {
      ...defaultOptions,
      timeZone: 'UTC',
    }).format(date);
  } catch (e) {
    return date;
  }
};

export const formatDateValue = (date: number, locale: string) => {
  try {
    return new Intl.DateTimeFormat(locale, defaultOptions).format(date);
  } catch (e) {
    return date;
  }
};

export const formatShortDateValue = (date: number, locale: string) => {
  try {
    return new Intl.DateTimeFormat(locale, { timeZone: 'UTC' }).format(date);
  } catch (e) {
    return date;
  }
};

export const formatDateTime = (date: Date) => {
  const options = {
    ...defaultOptions,
    hour: '2-digit',
    minute: '2-digit',
  };
  try {
    return new Intl.DateTimeFormat(i18next.languages, options).format(date);
  } catch (e) {
    return date;
  }
};
